module.exports = __webpack_public_path__ + "img/setup-analytics-amico.a3b1564a.svg";